import { useEffect, useState } from "react";
import { useT } from "@/i18n/I18nContext";

const CITIES_EN = [
  "Brooklyn", "Queens", "Bronx", "Manhattan", "Staten Island",
  "Newark", "Jersey City", "Paterson", "Yonkers", "Hoboken",
  "Edison", "Long Island", "Elizabeth", "Trenton",
];
const NAMES = [
  "Marcus", "Sofia", "Jamal", "Diana", "Carlos", "Aisha", "Tony",
  "Maria", "Devon", "Priya", "Kevin", "Luis", "Erin", "Naomi",
  "Andre", "Camila", "Brett", "Yasmin", "Jorge",
];
const ACTIONS = ["intake", "estimate", "match", "settled"];

function pick(arr) {
  return arr[Math.floor(Math.random() * arr.length)];
}

function makeBlurb() {
  return {
    id: Date.now() + Math.random(),
    name: pick(NAMES),
    city: pick(CITIES_EN),
    action: pick(ACTIONS),
    minutes: Math.floor(Math.random() * 18) + 2,
  };
}

/** Rotating "Marcus from Queens · 2 min ago" social proof in the corner. */
export default function SocialProofTicker() {
  const t = useT();
  const [item, setItem] = useState(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const start = setTimeout(() => {
      setItem(makeBlurb());
      setVisible(true);
    }, 4500);
    const cycle = setInterval(() => {
      setVisible(false);
      setTimeout(() => {
        setItem(makeBlurb());
        setVisible(true);
      }, 600);
    }, 9000);
    return () => {
      clearTimeout(start);
      clearInterval(cycle);
    };
  }, []);

  if (!item) return null;
  const actionText = t(`social.action.${item.action}`);
  return (
    <div
      className={`fixed bottom-24 left-4 z-30 hidden max-w-xs rounded-2xl border bg-white px-4 py-3 shadow-lg transition-all duration-500 md:bottom-6 md:flex md:items-center md:gap-3 ${
        visible ? "translate-y-0 opacity-100" : "translate-y-2 opacity-0 pointer-events-none"
      }`}
      style={{ borderColor: "var(--border)" }}
      data-testid="social-proof-ticker"
    >
      <div className="grid h-9 w-9 shrink-0 place-items-center rounded-full bg-[#E6F6ED] font-bold text-[#166534]">
        {item.name[0]}
      </div>
      <div className="text-xs leading-tight text-[#0B1317]">
        <div className="font-bold text-[#11322A]">
          {item.name} <span className="font-medium text-[#5C6B68]">· {item.city}</span>
        </div>
        <div className="text-[#5C6B68]">{actionText}</div>
        <div className="mt-0.5 text-[10px] font-bold uppercase tracking-wider text-[#E85D04]">
          {item.minutes} min ago
        </div>
      </div>
    </div>
  );
}
